import { Button, Flex, Box, Heading, Stack, Text } from "@chakra-ui/react";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { Filter } from "../../components/Filter";
import { FormModal } from "../../components/Forms/FormModal";
import { useFeatureToggles } from "../../hooks/useFeatureToggles";
import { FeatureToggleModel } from "../../models/FeatureToggle";
import { DoubleUserIcon } from "../../styles/icons/DoubleUserIcon";
import { Transfer } from 'antd';
import { SellersModel } from "../../models/Sellers";
import { api } from "../../services/Api";
import { showToast, useUserInfo } from "../../utils";

export function FeatureToggles() {
    const [initialData, setInitialData] = useState([]);
    const [sellers, setSellers] = useState<SellersModel[]>([]);
    const [filteredInitialData, setFilteredInitialData] = useState([]);
    const [mockData, setMockData] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFeatureLoading, setIsFeatureLoading] = useState(false);
    const [selectedFeatureToggle, setSelectedFeatureToggle] = useState({} as any);
    const { loadInitialData, postFeatureToggles } = useFeatureToggles();
    const { roles } = useUserInfo();

    const columns: ColumnsType<FeatureToggleModel> = [
        {
            key: "name",
            title: "Feature toggles",
            dataIndex: "name",
            render: (name, record) => (
                <Text>
                    {record?.name}
                </Text>
            )
        },
        {
            key: "buttonOptions",
            title: "",
            render: (name, record) => (
                <Button
                    onClick={() => {
                        setSelectedFeatureToggle(record);
                        setIsFeatureModalOpen(true);
                    }}
                    borderRadius="2px"
                    backgroundColor="#C3CAD7"
                    fontWeight={500}

                >
                    Editar
                </Button>
            ),
        },
    ];
    async function getInitialData() {
        try {
            setIsFeatureLoading(true);
            const response = await loadInitialData();
            const response_seller = await api.get(`/sellers?page=0&size=20000`);
            setSellers(response_seller.data.content);
            setInitialData(response.data);
            setFilteredInitialData(response.data);

        } catch (error) {
            setSellers([])
            error?.response?.data?.errors?.map((error: any) => (
                showToast({
                    type: "error",
                    message: `${error?.code} - ${error?.description}`
                })
            ));
        } finally {
            setIsFeatureLoading(false);
        }
    }
    useEffect(() => {
        getInitialData()
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        const tempTargetKeys = [];
        const tempMockData = [];
        sellers?.forEach((seller) => {
            const data = {
                key: seller?.id,
                title: seller?.companyName,
                description: '',
                chosen: selectedFeatureToggle?.betaSellers?.includes(seller?.id),
            };
            if (data.chosen) {
                tempTargetKeys.push(data.key);
            }
            tempMockData.push(data);
            setMockData(tempMockData);
            setTargetKeys(tempTargetKeys);
            return
        })
        //eslint-disable-next-line
    }, [selectedFeatureToggle])

    function handleSearch(search: string) {
        if (search === "") {
            setFilteredInitialData(initialData)
            return
        } else {
            const filteredInitialData = initialData?.filter((data: any) => data?.name?.toLowerCase()?.includes(search?.toLowerCase()));
            setFilteredInitialData(filteredInitialData)
        }
    }

    const filterOption = (inputValue: string, option: any) => option.title.indexOf(inputValue) > -1;

    const handleChange = (newTargetKeys) => {
        setTargetKeys(newTargetKeys);
    };

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const formData = {
                toggleName: selectedFeatureToggle?.name,
                sellerIds: targetKeys
            }
            await postFeatureToggles(formData);
            showToast({
                type: "success",
                message: `${selectedFeatureToggle?.name} atualizado com sucesso.`
            })
        } catch (error) {
            error?.response?.data?.errors?.map((error: any) => (
                showToast({
                    type: "error",
                    message: `${error?.code} - ${error?.description}`
                })
            ));
        } finally {
            setIsLoading(false);
            setTargetKeys([]);
            setSelectedFeatureToggle({} as any);
            setIsFeatureModalOpen(false);
            getInitialData();
        }
    }
    return (
        <>
            {isFeatureModalOpen && (
                <FormModal
                    title={`Editar - ${selectedFeatureToggle?.name}.`}
                    isOpen={isFeatureModalOpen}
                    onClose={() => {
                        setSelectedFeatureToggle({} as any);
                        setIsFeatureModalOpen(false);
                    }}
                    isSubmitting={isLoading}
                    
                    handleConfirmModal={handleSubmit}
                    confirmationButtonText="Salvar alterações"
                    width="850px"
                    isAllowToSubmit={roles?.includes("BARTE_FEATURE_TOGGLE")}
                >

                    <Flex
                        align={"center"}
                        justify={"center"}

                    >
                        <Box
                            borderRadius="8px"
                            border="1px solid #E2E8F0"
                            backgroundColor="yellow.100"
                            padding="16px"
                        >
                            <Text
                            
                            > Campo Beta Sellers vazio indica que a feature esta liberada para todos os Sellers</Text>
                        </Box>
                    </Flex>

                    <Flex
                        w="100%"
                        alignItems="center"
                        justify="center"
                    >
                        <Transfer
                            titles={['Todos os Sellers', 'Beta Sellers']}
                            dataSource={mockData}
                            showSearch
                            filterOption={filterOption}
                            targetKeys={targetKeys}
                            onChange={handleChange}
                            render={(item) => item.title}
                            listStyle={{
                                width: 300,
                                height: 300,
                            }}
                        />
                    </Flex>
                </FormModal>
            )}
            <Flex
                justifyContent="center"
            >
                <Stack w="100%" gap={2}>
                    <Flex
                        align="center"
                        gap="16px"
                    >
                        <DoubleUserIcon />
                        <Heading fontSize="24px">
                            Feature Toggles
                        </Heading>
                    </Flex>
                    <Filter
                        placeholder="Buscar feature toggle"
                        needToSubmit
                        onSubmitSearch={handleSearch}
                    />
                    <Table<FeatureToggleModel>
                        columns={columns}
                        dataSource={filteredInitialData}
                        rowKey={(record) => record?.name}
                        pagination={false}
                        locale={{ emptyText: "Sem feature toggles cadastradas." }}
                        loading={isFeatureLoading}
                    />
                </Stack>
            </Flex>
        </>
    )
}